(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["landing-page-ugc"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lp-testimonial-carousel')) {
    customElements.define('lp-testimonial-carousel', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const track = this.querySelector('.lp-testimonials__track');
        const position = this.querySelector('.lp-testimonials__position');
        if (!track || !position) return;
        const total = track.children.length;
        this.querySelectorAll('[data-direction]').forEach(button => {
          button.addEventListener('click', () => {
            const current = Math.round(track.scrollLeft / track.clientWidth);
            const next = (current + Number(button.dataset.direction) + total) % total;
            track.scrollTo({ left: next * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
          }, options);
        });
        track.addEventListener('scroll', () => {
          const current = Math.min(total, Math.round(track.scrollLeft / track.clientWidth) + 1);
          position.textContent = current + ' / ' + total;
        }, { ...options, passive: true });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rd-lymphoria-hero"] && !Shopify.designMode) return;
  try {
    
  const ab869en6v4eStates = new WeakMap()
  const ab869en6v4eBoxes = new Map()
  let ab869en6v4eCartPending = false
  const ab869en6v4eLockedSections = new Set()
  const rdlPendingHistory = new WeakMap()
  const rdlUserChoices = new WeakMap()
  let rdlRenderedUrl = rdlHistoryUrl()
  let rdlNavigationId = 0

  function rdlSetupGallery(gallery) {
    if (gallery.dataset.galleryBound === 'true') {
      return
    }

    const viewport = gallery.querySelector('[data-rd-male-viewport]')
    const slides = gallery.querySelectorAll('.rd-male-gallery__slide')
    const thumbs = gallery.querySelectorAll('[data-rd-male-thumb]')
    if (!viewport || !slides.length) {
      return
    }

    gallery.dataset.galleryBound = 'true'

    function syncThumbs() {
      const index = Math.round(viewport.scrollLeft / viewport.clientWidth)
      thumbs.forEach((thumb, i) => {
        thumb.classList.toggle('is-active', i === index)
        if (i === index) {
          thumb.setAttribute('aria-current', 'true')
        } else {
          thumb.removeAttribute('aria-current')
        }
      })
    }

    gallery.querySelectorAll(
      '[data-rd-male-thumb], [data-rd-male-prev], [data-rd-male-next]'
    ).forEach((control) => {
      control.addEventListener('click', () => {
        const current = Math.round(viewport.scrollLeft / viewport.clientWidth)
        const thumb = control.getAttribute('data-rd-male-thumb')
        const direction = control.hasAttribute('data-rd-male-next') ? 1 : -1
        const requested = thumb === null ? current + direction : Number(thumb)
        const target = Math.max(0, Math.min(slides.length - 1, requested))
        viewport.scrollTo({
          left: target * viewport.clientWidth,
          behavior: 'smooth',
        })
      })
    })

    viewport.addEventListener('scroll', syncThumbs, { passive: true })
  }

  function rdlSetupGalleries(root) {
    root.querySelectorAll('[data-rd-male-gallery]').forEach(rdlSetupGallery)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      rdlSetupGalleries(document)
    })
  } else {
    rdlSetupGalleries(document)
  }

  document.addEventListener('shopify:section:load', (event) => {
    rdlSetupGalleries(event.target)
  })

  /**
   * Sync the ATC button, form inputs and gallery from a bundle element's data
   * attributes. Shared by the original `.rdl-bundle` radios and the V2
   * `.fresh-buy-card` labels, which expose the same attribute names.
   * @param {Element} section
   * @param {Element} target element carrying data-price-now/-was, data-variant-id,
   *   data-selling-plan, data-refills, data-image, data-srcset, data-alt-price
   *   and (V2 only) data-quantity
   */
  function rdlSyncBuyArea(section, target) {
    if (!section || !target) return;

    var priceEl = section.querySelector('[data-rdl-atc-price]');
    var wasEl = section.querySelector('[data-rdl-atc-was]');
    var idInput = section.querySelector('[data-rdl-variant-input]');
    var spInput = section.querySelector('[data-rdl-selling-plan-input]');
    var refillsEl = section.querySelector('[data-rdl-refills-label]');
    var qtyInput = section.querySelector('[data-rdl-quantity-input]');
    var altEl = section.querySelector('[data-rdl-altperk]');

    if (priceEl && target.dataset.priceNow) priceEl.innerHTML = target.dataset.priceNow;
    if (wasEl) {
      wasEl.innerHTML = target.dataset.priceWas || ''
      wasEl.hidden = !target.dataset.priceWas
    }
    if (idInput && target.dataset.variantId) idInput.value = target.dataset.variantId;
    if (spInput) spInput.value = target.dataset.sellingPlan || '';
    if (refillsEl && target.dataset.refills) refillsEl.textContent = target.dataset.refills;
    if (qtyInput) qtyInput.value = target.dataset.quantity || '1';
    if (altEl) {
      if (target.dataset.altPrice) {
        altEl.removeAttribute('hidden');
      } else {
        altEl.setAttribute('hidden', '');
      }
    }

    // Swap the active gallery + thumb images to the selected bundle pack shot.
    if (target.dataset.image) {
      var mainImg =
        section.querySelector('.main_slider .swiper-slide-active img') ||
        section.querySelector('.main_slider .swiper-slide img');
      if (mainImg) {
        mainImg.src = target.dataset.image;
        if (target.dataset.srcset) {
          mainImg.srcset = target.dataset.srcset;
        } else {
          mainImg.removeAttribute('srcset');
        }
      }

      var thumbImg =
        section.querySelector('.thumbs_slider .swiper-slide-thumb-active img') ||
        section.querySelector('.thumbs_slider .swiper-slide img');
      if (thumbImg) {
        thumbImg.src = target.dataset.image;
      }
    }
  }

  /**
   * Apply a bundle selection (1x / 3x / 6x) and sync ATC / form fields from its
   * data attributes. Used after flavour/format swaps so the retained bundle
   * is correct before the new section is painted.
   * @param {Element} section
   * @param {string} bundleValue
   */
  function rdlApplyBundleSelection(section, bundleValue) {
    if (!section || !bundleValue) {
      return
    }
    const target = section.querySelector('.rdl-bundle__input[value="' + bundleValue + '"]')
    if (!target || (bundleValue === '6x' && !section.classList.contains('ab-869en6v4e-six-bags'))) {
      return
    }
    section.querySelectorAll('.rdl-bundle__input').forEach((input) => {
      input.checked = input === target
    })
    rdlSyncBuyArea(section, target)
    rdlSyncBuildMode(section, bundleValue)
    if (!section.classList.contains('ab-869en6v4e-six-bags')) {
      rdlMirrorFreshSelection(section, bundleValue)
    }
    ab869en6v4eLockPending(section)
  }

  /**
   * Apply a V2 ("fresh") bundle card selection: paint the card + gift panel,
   * then run the same buy-area sync the original radios use.
   * Card 1 has no gift panel, so only cards 2+ ever open (matches the design).
   * @param {Element} section
   * @param {Element} card the `.fresh-buy-card` to select
   */
  function rdlApplyFreshSelection(section, card) {
    if (!section || !card) return;
    if (card.dataset.bundleValue === '6x' && !section.classList.contains('ab-869en6v4e-six-bags')) {
      return
    }

    var cards = section.querySelectorAll('.fresh-buy-card');
    cards.forEach(function (other) {
      var isTarget = other === card;
      other.classList.toggle('is-selected', isTarget);

      var input = other.querySelector('input');
      if (input) input.checked = isTarget;

      var wrap = other.closest('.fresh-buy-option-wrap');
      if (!wrap) return;
      var panel = wrap.querySelector('.fresh-gift-panel');
      var isOpen = isTarget && !!panel;
      wrap.classList.toggle('is-open', isOpen);
      if (panel) panel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    });

    rdlSyncBuyArea(section, card);
    rdlSyncBuildMode(section, card.dataset.bundleValue);
    ab869en6v4eLockPending(section)

    // Keep the original cards in step while both sets are on the page. 6x has no
    // twin radio, so this leaves every one unchecked — which matters because
    // rdlIsBuildMode reads the checked radio directly. Skipping the reset when
    // there is no twin left a stale 3x check behind, and Add to Cart then took
    // the build-mode branch and returned without adding the 6-bag bundle.
    var twin = section.querySelector('.rdl-bundle__input[value="' + card.dataset.bundleValue + '"]');
    section.querySelectorAll('.rdl-bundle__input').forEach(function (input) {
      input.checked = input === twin;
    });
  }

  /**
   * Mirror an original-card selection onto the V2 cards (the reverse of the
   * sync in rdlApplyFreshSelection). No-op when V2 is not rendered.
   * @param {Element} section
   * @param {string} bundleValue
   */
  function rdlMirrorFreshSelection(section, bundleValue) {
    var shell = section.querySelector('[data-fresh-bundles]');
    if (!shell) return;
    var card = shell.querySelector('.fresh-buy-card[data-bundle-value="' + bundleValue + '"]');
    if (!card || card.classList.contains('is-selected')) return;
    rdlApplyFreshSelection(section, card);
  }

  /**
   * Restore the live picker, including the explicitly activated six-bag option.
   * @param {HTMLElement} section - Product picker.
   * @param {string} bundleValue - Selected bundle size.
   * @returns {void}
   */
function rdlApplyRetainedSelection(section, bundleValue) {
  if (typeof window !== 'undefined' && window.ab869en6v4eSixBags) {
    ab869en6v4eActivate(section)
    rdlApplyBundleSelection(section, bundleValue)
    return
  }

  const shell = section.querySelector('[data-fresh-bundles]')
  const card = shell
    ? shell.querySelector(
      '.fresh-buy-card[data-bundle-value="' + bundleValue + '"]',
    )
    : null

  if (card) {
    rdlApplyFreshSelection(section, card)
    return
  }

  const retained = section.querySelector(
    '.rdl-bundle__input[value="' + bundleValue + '"]',
  )
  const fallback = section.querySelector('.rdl-bundle__input:checked')
  const next = retained || fallback

  if (next) {
    rdlApplyBundleSelection(section, next.value)
  }
}

  /**
   * Apply a linked subscription when the rendered picker offers that exact
   * available variant and plan. Other queries keep the existing default.
   * @param {Element} section - Product section containing the bundle pickers.
   * @returns {void}
   */
  function rdlApplyPurchaseQuery(section) {
    const params = new URLSearchParams(window.location.search)
    const variantId = params.get('variant')
    const sellingPlanId = params.get('selling_plan')

    if (!variantId || !sellingPlanId) {
      return
    }

    const candidates = section.querySelectorAll('.rdl-bundle__input, .fresh-buy-card')
    const target = Array.from(candidates).find((item) => (
      item.dataset.variantId === variantId &&
      item.dataset.sellingPlan === sellingPlanId &&
      item.dataset.available === 'true' &&
      (!item.dataset.quantity || item.dataset.quantity === '1')
    ))

    if (target) {
      rdlApplyRetainedSelection(section, target.dataset.bundleValue || target.value)
    }
  }

  // Bundle radio → ATC price/variant swap (event delegation, survives section AJAX swap).
  document.addEventListener('change', function (e) {
    if (!e.target || !e.target.checked) {
      return
    }
    const freshCard = e.target.closest('.fresh-buy-card')
    if (freshCard && window.ab869en6v4eSixBags === true) {
      const freshSection = freshCard.closest('[data-rdl-section]')
      rdlApplyFreshSelection(freshSection, freshCard)
      rdlRememberChoice(freshSection)
      return
    }
    if (e.target.name !== 'rdl-bundle') {
      return
    }
    var section = e.target.closest('[data-rdl-section]') || document;
    rdlApplyBundleSelection(section, e.target.value);
    rdlRememberChoice(section)
  });

  // V2 card → same swap. Delegated on click (the card is a <label>, so relying
  // on the radio's `change` would miss re-clicks on the already-checked card).
  document.addEventListener('click', function (e) {
    var card = e.target.closest ? e.target.closest('.fresh-buy-card') : null;
    if (!card) return;
    var section = card.closest('[data-rdl-section]') || document;
    rdlApplyFreshSelection(section, card);
    rdlRememberChoice(section)
  });

  // Free-gift-with-subscription helpers (mirrors snippets/flavour-bundle.liquid).
  function rdlNormalizeVariantId(variantId) {
    if (typeof variantId !== 'string') return variantId;
    if (variantId.indexOf('gid://shopify/ProductVariant/') !== -1) {
      return variantId.split('/').pop();
    }
    return variantId;
  }

  function rdlBuildParentWithGiftLines(parentLine, giftLines) {
    var gifts = Array.isArray(giftLines) ? giftLines : [];
    if (gifts.length === 0) return [parentLine];
    return gifts.slice().reverse().concat(parentLine);
  }

  /**
   * Shared cart-add helper — POST to /cart/add.js, fetch cart, dispatch events.
   * @param {Array}        items   - Array of line item objects for /cart/add.js
   * @param {Element|null} button  - ATC button (toggled is-loading/disabled)
   * @param {Element|null} errorEl - Element to show error messages
   */
  function rdlDoCartAdd(items, button, errorEl) {
    const ab869en6v4eRequest = window.ab869en6v4eSixBags === true
    if (ab869en6v4eRequest) {
      ab869en6v4eCartPending = true
      const section = button?.closest('[data-rdl-section]')
      if (section) {
        ab869en6v4eLockedSections.add(section)
      }
    }
    if (button) {
      button.disabled = true;
      button.classList.add('is-loading');
    }
    document.dispatchEvent(new CustomEvent('cart:item-change-pending', { bubbles: true }))
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (data) {
            throw new Error(data.description || 'Could not add to cart');
          });
        }
        return res.json();
      })
      .then(function () {
        return fetch('/cart.js', { credentials: 'include' }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:changed', { bubbles: true, detail: { cart: cart, cartData: cart } }));
        document.dispatchEvent(new CustomEvent('cart:item-added', { bubbles: true, detail: { cart: cart, cartData: cart } }));
        setTimeout(function () {
          var drawerBtn = document.querySelector('[data-action="show-cart-drawer"]');
          if (drawerBtn) drawerBtn.click();
        }, 600);
      })
      .catch(function (err) {
        document.dispatchEvent(new CustomEvent('cart:error', { detail: { errorMessage: err.message } }))
        console.error('rdl-hero ATC:', err);
        if (errorEl) {
          errorEl.textContent = err.message || 'Sorry, something went wrong. Please try again.';
          errorEl.removeAttribute('hidden');
        }
      })
      .finally(function () {
        if (ab869en6v4eRequest) {
          ab869en6v4eCartPending = false
        }
        if (button) {
          button.disabled = false;
          button.classList.remove('is-loading');
        }
        if (ab869en6v4eRequest) {
          ab869en6v4eRestoreButtons()
        }
      });
  }

  // Add to Cart — AJAX submit (matches site-wide cart drawer pattern) instead of
  // the default form POST, which would redirect to /cart.
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.rdl-form');
    if (!form) return;
    e.preventDefault();

    var section = form.closest('[data-rdl-section]') || document;
    var idInput = form.querySelector('[data-rdl-variant-input]');
    var spInput = form.querySelector('[data-rdl-selling-plan-input]');
    var button = form.querySelector('.rdl-atc');
    var errorEl = form.querySelector('[data-rdl-atc-error]');

    if (ab869en6v4eCartPending) {
      return
    }

    if (errorEl) {
      errorEl.textContent = '';
      errorEl.setAttribute('hidden', '');
    }

    if (ab869en6v4eIsActive(section)) {
      ab869en6v4eAddToCart(section, button, errorEl)
      return
    }

    // ── Build-mode branch (3x bundle selected) ──
    if (typeof rdlIsBuildMode === 'function' && rdlIsBuildMode(section)) {
      var total = typeof rdlBundleTotal === 'function' ? rdlBundleTotal() : 0;
      if (total !== 3) return;

      var activeEntries = Object.keys(rdlBundleState).filter(function (k) {
        return rdlBundleState[k] > 0;
      }).map(function (k) {
        return { flavour: k, qty: rdlBundleState[k] };
      });

      var isMixed = activeEntries.length > 1;

      // Same-flavour × 3 that matches the server-rendered var_3x → use normal path
      var checked3x = section.querySelector('.rdl-bundle__input[value="3x"]');
      var serverFlavour = checked3x ? checked3x.getAttribute('data-bundle-flavour') : null;
      var useSameFlavourPath = !isMixed
        && activeEntries.length === 1
        && activeEntries[0].flavour === serverFlavour;

      if (!useSameFlavourPath) {
        // Mixed flavours (or same-flavour different from server-rendered):
        // one Skio Static Box parent line, with _pvgid flavour quantities
        // so Skio creates $0 child lines at order time.
        var config = window.rdlBundleConfig || {};
        var staticBoxVariantId = parseInt(config.staticBoxVariantId, 10) || 0;
        var staticBoxSellingPlanId = parseInt(config.staticBoxSellingPlanId, 10) || 0;

        if (!staticBoxVariantId) {
          console.warn('[RDL Bundle] Static box variant ID is not configured.');
          if (errorEl) {
            errorEl.textContent = 'Mixed bundles will be available very soon — select 3 of the same flavour to add today.';
            errorEl.removeAttribute('hidden');
          }
          return;
        }

        if (button) {
          button.disabled = true;
          button.classList.add('is-loading');
        }

        rdlEnsureStaticBox().then(function () {
          var properties = {};
          var bundleParts = [];
          var missingFlavour = null;
          var boxGroupId =
            Date.now() + '-' + Math.random().toString(16).slice(2);

          activeEntries.forEach(function (entry) {
            var tile = section.querySelector(
              '[data-rdl-build-tile][data-flavour="' + entry.flavour + '"]'
            );
            var flavourName = tile
              ? (tile.getAttribute('data-flavour-name') || '').trim()
              : '';
            var boxVarId = rdlFindBoxVariantId(flavourName);
            if (!boxVarId) {
              missingFlavour = flavourName || entry.flavour;
              return;
            }
            // The _pvgid properties are the Skio Static Box contract: Skio reads
            // them at order time and adds each flavour as a $0 child line itself.
            // Never add those same flavours as cart lines here as well — they
            // would land on the order twice.
            properties['_pvgid://shopify/ProductVariant/' + boxVarId] = entry.qty;
            bundleParts.push(entry.qty + 'x ' + (flavourName || entry.flavour));
          });

          if (missingFlavour) {
            throw new Error(
              missingFlavour +
                ' is not available in this mixed bundle. Please choose a different flavour.'
            );
          }

          var firstTile = section.querySelector(
            '[data-rdl-build-tile][data-flavour="' +
              activeEntries[0].flavour +
              '"]'
          );
          var giftLookupId = firstTile
            ? parseInt(firstTile.getAttribute('data-gift-variant-id'), 10)
            : 0;

          var giftMap =
            window.ThatWorks &&
            window.ThatWorks.freeGiftsWithSubscriptionOfVariants
              ? window.ThatWorks.freeGiftsWithSubscriptionOfVariants
              : null;
          var fgMixed = giftMap ? giftMap[staticBoxVariantId] : null;
          if (
            (!Array.isArray(fgMixed) || fgMixed.length === 0) &&
            giftMap &&
            giftLookupId
          ) {
            fgMixed = giftMap[giftLookupId];
          }
          var hasFgMixed = Array.isArray(fgMixed) && fgMixed.length > 0;

          var parentProperties = Object.assign({}, properties);
          parentProperties._box_group_id = boxGroupId;
          // Human-readable box contents. Drives the flavour rows in the cart
          // drawer (cart-item.liquid `Bundle` branch) and shows under the line
          // at checkout, where Skio's $0 children do not exist yet.
          if (bundleParts.length > 0) {
            parentProperties.Bundle = bundleParts.join(', ');
          }
          if (hasFgMixed && staticBoxSellingPlanId > 0) {
            parentProperties._free_gift_parent = 'true';
            parentProperties._free_gift_group_id = boxGroupId;
            parentProperties._free_gift_parent_variant_id = String(
              staticBoxVariantId
            );
            parentProperties._is_free_gift = 'false';
          }

          var fgMixedItems = hasFgMixed
            ? fgMixed
                .map(function (gift) {
                  var gv = rdlNormalizeVariantId(gift.variantId);
                  if (
                    !gv ||
                    gift.autoAddDisabled === true ||
                    gift.autoAddDisabled === 'true'
                  ) {
                    return null;
                  }
                  return {
                    id: gv,
                    quantity: 1,
                    parent_id: staticBoxVariantId,
                    properties: {
                      _is_free_gift: 'true',
                      __free_gift: true,
                      _free_gift_child: 'true',
                      _free_gift_group_id: boxGroupId,
                      _free_gift_parent_variant_id: String(staticBoxVariantId),
                    },
                  };
                })
                .filter(Boolean)
            : [];

          if (fgMixedItems.length > 0) {
            parentProperties.__free_gift_items = fgMixedItems
              .map(function (item) {
                return String(item.id);
              })
              .join(',');
          }

          var parentLine = {
            id: staticBoxVariantId,
            quantity: 1,
            properties: parentProperties,
          };
          if (staticBoxSellingPlanId > 0) {
            parentLine.selling_plan = staticBoxSellingPlanId;
          }

          rdlDoCartAdd(
            [parentLine].concat(fgMixedItems),
            button,
            errorEl
          );
        }).catch(function (err) {
          console.error('rdl-hero ATC:', err);
          if (errorEl) {
            errorEl.textContent =
              err.message || 'Sorry, something went wrong. Please try again.';
            errorEl.removeAttribute('hidden');
          }
          if (button) {
            button.disabled = false;
            button.classList.remove('is-loading');
          }
        });
        return;
      }
      // Same-flavour × 3 matching server-rendered flavour: fall through to normal path
    }
    // ── End build-mode branch ─────────────────────────────────────────

    var variantId = idInput ? parseInt(idInput.value, 10) : 0;
    var sellingPlanId = spInput && spInput.value ? parseInt(spInput.value, 10) : 0;
    var qtyInput = form.querySelector('[data-rdl-quantity-input]');
    var quantity = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    if (!quantity || quantity < 1) quantity = 1;
    if (!variantId) return;

    var items;
    if (sellingPlanId > 0) {
      var freeGifts = window.ThatWorks && window.ThatWorks.freeGiftsWithSubscriptionOfVariants
        ? window.ThatWorks.freeGiftsWithSubscriptionOfVariants[variantId]
        : null;
      var hasFreeGifts = Array.isArray(freeGifts) && freeGifts.length > 0;
      var freeGiftGroupId = Date.now() + '-' + Math.random().toString(16).slice(2);

      var parentProperties = {};
      if (hasFreeGifts) {
        parentProperties._free_gift_parent = 'true';
        parentProperties._free_gift_group_id = freeGiftGroupId;
        parentProperties._free_gift_parent_variant_id = String(variantId);
        parentProperties._is_free_gift = 'false';
      }

      var freeGiftItems = hasFreeGifts
        ? freeGifts.map(function (gift) {
            var giftVariantId = rdlNormalizeVariantId(gift.variantId);
            if (!giftVariantId || gift.autoAddDisabled === true || gift.autoAddDisabled === 'true') return null;
            return {
              id: giftVariantId,
              quantity: 1,
              properties: {
                _is_free_gift: 'true',
                __free_gift: true,
                _free_gift_child: 'true',
                _free_gift_group_id: freeGiftGroupId,
                _free_gift_parent_variant_id: String(variantId)
              }
            };
          }).filter(function (item) { return item !== null; })
        : [];

      if (freeGiftItems.length > 0) {
        parentProperties.__free_gift_items = freeGiftItems
          .map(function (item) { return String(item.id); })
          .join(',');
      }

      var parentLine = {
        id: variantId,
        quantity: quantity,
        selling_plan: sellingPlanId,
        properties: parentProperties
      };

      items = rdlBuildParentWithGiftLines(parentLine, freeGiftItems);
    } else {
      items = [{ id: variantId, quantity: quantity }];
    }

    rdlDoCartAdd(items, button, errorEl);
  });

  // "Ready to ship — arrives by..." date — computed client-side so it reflects
  // the viewer's actual current date (Liquid's `now` is fixed at render/cache
  // time). Mirrors the addBusinessDays/locale logic used by .pp_atc_meta_line
  // in snippets/old-cta-part.liquid. Idempotent, can be re-run after swap.
  window.rdlSetShipDate = function () {
    var els = document.querySelectorAll('[data-rdl-ship-date]');
    if (!els.length) return;

    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    function addBusinessDays(startDate, numDays) {
      var newDate = new Date(startDate);
      var businessDays = 0;
      while (businessDays < numDays) {
        newDate.setDate(newDate.getDate() + 1);
        if (newDate.getDay() !== 0) businessDays++;
      }
      return newDate;
    }

    function ordinalSuffix(day) {
      var mod100 = day % 100;
      if (mod100 >= 11 && mod100 <= 13) return 'th';
      switch (day % 10) {
        case 1: return 'st';
        case 2: return 'nd';
        case 3: return 'rd';
        default: return 'th';
      }
    }

    // Prefer the lead days configured for the visitor's country group (bridged
    // from Liquid via window.ThatWorks.countryDeliveryLeadDays). 0 means no group
    // matched, in which case keep the original market-URL behaviour.
    var configuredLeadDays =
      (window.ThatWorks && Number(window.ThatWorks.countryDeliveryLeadDays)) || 0;
    var currentUrl = String(window.location.href);
    var businessDayCount =
      configuredLeadDays > 0
        ? configuredLeadDays
        : currentUrl.indexOf('en-eu') !== -1 || currentUrl.indexOf('en-us') !== -1
          ? 5
          : 2;
    var shipDate = addBusinessDays(new Date(), businessDayCount);
    var day = shipDate.getDate();
    var formatted = months[shipDate.getMonth()] + ' ' + day + ordinalSuffix(day);

    els.forEach(function (el) { el.textContent = formatted; });
  };
  window.rdlSetShipDate();

  // IntersectionObserver init for the sold bar — idempotent, can be re-run after swap.
  window.rdlObserveSold = function () {
    var cards = document.querySelectorAll('[data-rdl-sold]:not(.rdl-observed)');
    if (!cards.length) return;
    if (typeof IntersectionObserver === 'undefined') {
      cards.forEach(function (c) { c.classList.add('is-visible'); c.classList.add('rdl-observed'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) entry.target.classList.add('is-visible');
        else entry.target.classList.remove('is-visible');
      });
    }, { threshold: 0.4 });
    cards.forEach(function (c) {
      c.classList.add('rdl-observed');
      io.observe(c);
    });
  };
  window.rdlObserveSold();

  // Format / Flavour click → AJAX-swap the hero section instead of a full page reload.
  document.addEventListener('click', function (e) {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
    var link = e.target.closest('.rdl-flavour, .rdl-format');
    if (!link) return;
    var section = link.closest('[data-rdl-section]');
    if (!section) return;
    // link.href is absolute. With a product override the links point to the
    // product's own PDP (a different path than the current page); on a real PDP
    // they point back to the current page.
    var url;
    try { url = new URL(link.href); } catch (err) { return; }
    var variantId = url.searchParams.get('variant');
    if (!variantId) return;

    // Cross-path = the section is placed on a non-product page via product_override,
    // so its links target the product's PDP. The Section Rendering API on the
    // current (non-product) page has no product context, so ?variant would be
    // ignored — instead fetch the product's PDP as a full page (where ?variant
    // resolves server-side) and extract this section from the response.
    var crossPath = url.pathname !== window.location.pathname;
    var sectionId = section.getAttribute('data-section-id');
    if (!crossPath && !sectionId) return;

    e.preventDefault();
    rdlSaveHistorySelection()
    const navigationId = ++rdlNavigationId
    section.classList.add('rdl-loading');

    const selectedBundle = section.querySelector('.rdl-bundle__input:checked')
    const retainedBundleValue = selectedBundle ? selectedBundle.value : '1x'

    var fetchUrl;
    if (crossPath) {
      // Keep the visible URL on the current page; only reflect the chosen variant.
      var displayParams = new URLSearchParams(window.location.search);
      displayParams.set('variant', variantId);
      history.pushState({}, '', window.location.pathname + '?' + displayParams.toString());
      // Fetch the product PDP (link target) with its view + variant params.
      fetchUrl = url.pathname + url.search;
    } else {
      // Same-path (rendered on the product's own PDP): use the lighter Section
      // Rendering API. Preserve existing query params; only change `variant`.
      var newParams = new URLSearchParams(window.location.search);
      newParams.set('variant', variantId);
      history.pushState({}, '', url.pathname + '?' + newParams.toString());
      var apiParams = new URLSearchParams(newParams);
      apiParams.set('section_id', sectionId);
      fetchUrl = url.pathname + '?' + apiParams.toString();
    }

    const destination = rdlHistoryUrl()
    fetch(fetchUrl, { credentials: 'same-origin', headers: { 'Accept': 'text/html' } })
      .then(function (r) { if (!r.ok) throw new Error('Section fetch ' + r.status); return r.text(); })
      .then(function (html) {
        if (navigationId !== rdlNavigationId) {
          return
        }
        var tmp = document.createElement('div');
        tmp.innerHTML = html.trim();
        var newSection = tmp.querySelector('[data-rdl-section]');
        // Guard: if the fetched section is missing key elements, treat as failure.
        if (!newSection || !newSection.querySelector('.rdl-flavours') || !newSection.querySelector('.rdl-bundles')) {
          throw new Error('Section response missing expected elements');
        }

        // Apply retained bundle before paint so 1x never flashes first.
        rdlApplyRetainedSelection(newSection, retainedBundleValue);

        section.replaceWith(newSection);
        rdlRenderedUrl = destination
        rdlSaveHistorySelection()

        window.rdlObserveSold();
        window.rdlSetShipDate();
        // Section swap inserts new gallery markup but does not re-run snippet
        // scripts — re-wire desktop thumb arrows on the new slider.
        if (typeof window.initLympPdpGallery === 'function') {
          window.initLympPdpGallery();
        } else {
          document.dispatchEvent(new CustomEvent('lymp:gallery-refreshed'));
        }
      })
      .catch(function (err) {
        if (navigationId !== rdlNavigationId) {
          return
        }
        console.warn('rdl-hero swap fell back to navigation:', err);
        window.location.href = link.href;
      });
  });

  // ============================================================
  //  BUILD-YOUR-BUNDLE
  //
  //  Selecting the 3x bundle shows the quantity selectors.
  //  Default allocation is the current flavour × 3.
  // ============================================================

  var rdlStaticBoxCache = null;
  var rdlStaticBoxPromise = null;

  /**
   * Fetch and cache Skio Static Box selectable variants.
   * @returns {Promise<Array>}
   */
  function rdlEnsureStaticBox() {
    if (rdlStaticBoxCache) {
      return Promise.resolve(rdlStaticBoxCache);
    }
    if (rdlStaticBoxPromise) {
      return rdlStaticBoxPromise;
    }

    var config = window.rdlBundleConfig || {};
    var variantId = String(config.staticBoxVariantId || '').trim();
    var sellingPlanId = String(config.staticBoxSellingPlanId || '').trim();
    if (!variantId) {
      return Promise.reject(new Error('Static box is not configured.'));
    }

    var body = { productVariantPlatformId: variantId };
    if (sellingPlanId) {
      body.sellingPlanPlatformId = sellingPlanId;
    }

    rdlStaticBoxPromise = fetch(
      'https://api.skio.com/storefront-http/get-classic-box-v2',
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      }
    )
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (!data || !data.ok || !data.ClassicBoxV2) {
          throw new Error('Failed to load mixed bundle options.');
        }
        rdlStaticBoxCache = data.ClassicBoxV2.selectableProductVariants || [];
        rdlStaticBoxPromise = null;
        return rdlStaticBoxCache;
      })
      .catch(function (err) {
        rdlStaticBoxPromise = null;
        throw err;
      });

    return rdlStaticBoxPromise;
  }

  /**
   * Map a flavour display name to the Static Box selectable variant ID.
   * @param {string} flavourName
   * @returns {number}
   */
  function rdlFindBoxVariantId(flavourName) {
    if (!flavourName || !rdlStaticBoxCache) return 0;
    var target = String(flavourName).trim().toLowerCase();
    var match = rdlStaticBoxCache.find(function (variant) {
      var title = (variant.productVariantTitle || '')
        .split(' / ')[0]
        .trim()
        .toLowerCase();
      return title === target;
    });
    if (!match || !match.platformId) return 0;
    return parseInt(String(match.platformId).split('/').pop(), 10) || 0;
  }

  /**
   * Dim / disable build tiles whose flavour is not in the Static Box.
   * @param {Element} section
   */
  function rdlMarkBoxEligibility(section) {
    if (section && ab869en6v4eIsActive(section)) {
      return
    }
    if (!section || !rdlStaticBoxCache) return;

    var names = {};
    rdlStaticBoxCache.forEach(function (variant) {
      var title = (variant.productVariantTitle || '')
        .split(' / ')[0]
        .trim()
        .toLowerCase();
      if (title) names[title] = true;
    });

    section.querySelectorAll('[data-rdl-build-tile]').forEach(function (tile) {
      var flavourName = (tile.getAttribute('data-flavour-name') || '')
        .trim()
        .toLowerCase();
      var available = !!names[flavourName];
      tile.classList.toggle('rdl-build-tile--unavailable', !available);
    });

    if (section.classList.contains('rdl-bundle-mode')) {
      rdlRenderBuildUI(section);
    }
  }

  /**
   * Mixed bundles are added as a Skio Static Box line, so the builder is only
   * offered when the section has a static box variant configured. Sections
   * without one (e.g. landing pages) keep the plain 3x bundle.
   */
  function rdlBuilderConfigured(section) {
    if (!section || section.dataset.rdlBuilderEnabled !== 'true') return false;
    var config = window.rdlBundleConfig || {};
    return (parseInt(config.staticBoxVariantId, 10) || 0) > 0;
  }

  /**
   * Returns true when build mode should be active for a section:
   * the builder is configured and the 3x bundle radio is checked.
   * @param {Element} section
   */
  function rdlIsBuildMode(section) {
    if (!rdlBuilderConfigured(section)) return false;
    var checked = section.querySelector('.rdl-bundle__input:checked');
    return !!(checked && checked.value === '3x');
  }

  // Per-section allocation state: flavourHandle → quantity (integer)
  var rdlBundleState = {};

  /** Sum of all allocated quantities. */
  function rdlBundleTotal() {
    return Object.keys(rdlBundleState).reduce(function (sum, k) {
      return sum + (rdlBundleState[k] || 0);
    }, 0);
  }

  /**
   * Sync all tile visuals and the counter/ATC button from rdlBundleState.
   * @param {Element} section
   */
  function rdlRenderBuildUI(section) {
    var total = rdlBundleTotal();
    var maxReached = total >= 3;
    var hasUnavailableQty = false;
    section.querySelectorAll(
      '[data-rdl-build-tile].rdl-build-tile--unavailable'
    ).forEach(function (tile) {
      var fl = tile.getAttribute('data-flavour');
      if ((rdlBundleState[fl] || 0) > 0) hasUnavailableQty = true;
    });

    section.querySelectorAll('[data-rdl-build-tile]').forEach(function (tile) {
      var fl = tile.getAttribute('data-flavour');
      var qty = rdlBundleState[fl] || 0;
      var qtyEl = tile.querySelector('[data-rdl-tile-qty]');
      var minusBtn = tile.querySelector('[data-rdl-bundle-minus]');
      var plusBtn = tile.querySelector('[data-rdl-bundle-plus]');
      var unavailable = tile.classList.contains('rdl-build-tile--unavailable');

      tile.classList.toggle('is-active', qty > 0);

      if (qtyEl) {
        qtyEl.textContent = qty;
        qtyEl.style.display = qty > 0 ? '' : 'none';
      }
      if (minusBtn) {
        minusBtn.style.display = qty > 0 ? '' : 'none';
        minusBtn.disabled = qty <= 0;
      }
      if (plusBtn) {
        plusBtn.disabled = maxReached || unavailable ||
          (hasUnavailableQty && !unavailable);
      }
    });

    var counter = section.querySelector('[data-rdl-build-counter]');
    if (counter) {
      var counterText = counter.querySelector('[data-rdl-build-counter-text]');
      if (total >= 3) {
        if (counterText) counterText.textContent = '3/3 Selected';
        counter.classList.add('is-complete');
      } else {
        if (counterText) counterText.textContent = total + '/3 Selected';
        counter.classList.remove('is-complete');
      }
    }

    var atcBtn = section.querySelector('.rdl-atc');
    if (atcBtn) {
      atcBtn.disabled = total !== 3;
      atcBtn.classList.toggle('rdl-atc--incomplete', total !== 3);
    }
    ab869en6v4eLockPending(section)
  }

  /**
   * Write an allocation map into rdlBundleState and re-render all tiles.
   * @param {Element} section
   * @param {Object}  alloc  - { flavourHandle: quantity }
   */
  function rdlApplyAllocation(section, alloc) {
    rdlBundleState = {};
    section.querySelectorAll('[data-rdl-build-tile]').forEach(function (tile) {
      var fl = tile.getAttribute('data-flavour');
      rdlBundleState[fl] = alloc[fl] || 0;
    });
    rdlRenderBuildUI(section);
  }

  /**
   * Build the default allocation: current flavour × 3.
   * Falls back to the first tile when the selected flavour is not found.
   * @param {Element} section
   * @returns {Object}
   */
  function rdlDefaultBuild(section) {
    var alloc = {};
    section.querySelectorAll('[data-rdl-build-tile]').forEach(function (tile) {
      alloc[tile.getAttribute('data-flavour')] = 0;
    });
    var selected = section.querySelector('.rdl-flavour.is-selected');
    var currentFl = selected ? selected.getAttribute('data-flavour') : null;
    if (currentFl && Object.prototype.hasOwnProperty.call(alloc, currentFl)) {
      alloc[currentFl] = 3;
    } else {
      var first = Object.keys(alloc)[0];
      if (first) alloc[first] = 3;
    }
    return alloc;
  }

  /**
   * Enter build mode: add class, show build UI, apply defaults.
   * @param {Element} section
   */
  function rdlEnterBuildMode(section) {
    var alloc = rdlDefaultBuild(section);
    section.classList.add('rdl-bundle-mode');
    var buildEl = section.querySelector('.rdl-flavours__build');
    if (buildEl) buildEl.removeAttribute('aria-hidden');
    rdlApplyAllocation(section, alloc);
    rdlEnsureStaticBox().then(function () {
      rdlMarkBoxEligibility(section);
    }).catch(function (err) {
      console.warn('[RDL Bundle] Static box load failed:', err);
    });
  }

  /**
   * Exit build mode: remove class, re-enable ATC, reset state.
   * @param {Element} section
   */
  function rdlExitBuildMode(section) {
    section.classList.remove('rdl-bundle-mode');
    var buildEl = section.querySelector('.rdl-flavours__build');
    if (buildEl) buildEl.setAttribute('aria-hidden', 'true');
    rdlBundleState = {};
    var atcBtn = section.querySelector('.rdl-atc');
    if (atcBtn) {
      atcBtn.disabled = false;
      atcBtn.classList.remove('rdl-atc--incomplete');
    }
  }

  /**
   * Enter / exit build mode to match the selected bundle. Called from the shared
   * selection paths (original radios, V2 cards, retained selection after a
   * swap), so programmatic selections that never fire a native `change` event
   * stay in sync. Idempotent: re-selecting 3x keeps the current allocation.
   * @param {Element} section
   * @param {string} bundleValue
   */
  function rdlSyncBuildMode(section, bundleValue) {
    if (!section || !section.classList) return;
    if (window.ab869en6v4eSixBags === true && bundleValue === '6x' && ab869en6v4eConfigured(section)) {
      if (!ab869en6v4eIsActive(section)) {
        if (section.classList.contains('rdl-bundle-mode')) {
          rdlExitBuildMode(section)
        }
        ab869en6v4eEnter(section)
      }
      return
    }
    if (ab869en6v4eIsActive(section)) {
      ab869en6v4eExit(section)
    }
    var inBuildMode = section.classList.contains('rdl-bundle-mode');
    if (bundleValue === '3x' && rdlBuilderConfigured(section)) {
      if (!inBuildMode) rdlEnterBuildMode(section);
    } else if (inBuildMode) {
      rdlExitBuildMode(section);
    }
  }

  // Stepper +/- click handler (event-delegated, swap-safe)
  document.addEventListener('click', function (e) {
    var plusBtn = e.target.closest('[data-rdl-bundle-plus]');
    var minusBtn = e.target.closest('[data-rdl-bundle-minus]');
    if (!plusBtn && !minusBtn) return;
    e.preventDefault();
    e.stopPropagation();
    var section = (plusBtn || minusBtn).closest('[data-rdl-section]');
    if (!section) return;
    if (ab869en6v4eIsActive(section)) {
      ab869en6v4eStep(section, plusBtn || minusBtn, Boolean(plusBtn))
      rdlRememberChoice(section)
      return
    }
    var tile = (plusBtn || minusBtn).closest('[data-rdl-build-tile]');
    if (!tile) return;
    var fl = tile.getAttribute('data-flavour');
    var current = rdlBundleState[fl] || 0;
    var total = rdlBundleTotal();
    if (plusBtn && !plusBtn.disabled && total < 3) {
      rdlBundleState[fl] = current + 1;
    } else if (minusBtn && !minusBtn.disabled && current > 0) {
      rdlBundleState[fl] = current - 1;
    }
    rdlRenderBuildUI(section);
    rdlRememberChoice(section)
  });

  // On page load: if Intelligems has already set the activation class before
  // this script executes, check whether build mode should be active.
  (function rdlBundleInit() {
    var section = document.querySelector('[data-rdl-section]');
  if (section) {
    rdlApplyPurchaseQuery(section)
  }
    if (!section || !rdlBuilderConfigured(section)) return;
    rdlEnsureStaticBox().then(function () {
      rdlMarkBoxEligibility(section);
    }).catch(function (err) {
      console.warn('[RDL Bundle] Static box preload failed:', err);
    });
    var checked = section.querySelector('.rdl-bundle__input:checked');
    if (checked && checked.value === '3x' && rdlBuilderConfigured(section)) {
      rdlEnterBuildMode(section);
    }
  })();
  // ab-869en6v4e: isolated six-bag experiment. The three-bag path stays above.

  /**
   * Keep size changes from enabling a second treatment submission.
   * @param {HTMLElement} section - Product section whose selection just changed.
   * @returns {void}
   */
  function ab869en6v4eLockPending(section) {
    const button = section.querySelector('.rdl-atc')
    if (ab869en6v4eCartPending && button) {
      ab869en6v4eLockedSections.add(section)
      button.disabled = true
    }
  }

  /**
   * Restore treatment buttons after cart completion, including replaced sections.
   * @returns {void}
   */
  function ab869en6v4eRestoreButtons() {
    ab869en6v4eLockedSections.forEach((section) => {
      if (ab869en6v4eIsActive(section)) {
        ab869en6v4eRender(section)
      } else if (rdlIsBuildMode(section)) {
        rdlRenderBuildUI(section)
      } else {
        const button = section.querySelector('.rdl-atc')
        if (button) {
          button.disabled = false
        }
      }
    })
    ab869en6v4eLockedSections.clear()
  }

  /**
   * Resolve this section's six-bag subscription box.
   * @param {HTMLElement} section - Product section carrying merchant settings.
   * @returns {object} Variant ID, selling plan ID and their combined cache key.
   */
  function ab869en6v4eConfig(section) {
    const variantId = section.dataset.ab869en6v4eBoxVariantId || ''
    const sellingPlanId = section.dataset.ab869en6v4eBoxSellingPlanId || ''
    return {
      variantId,
      sellingPlanId,
      key: variantId + ':' + sellingPlanId,
    }
  }

  /**
   * Check that the merchant supplied both six-bag identifiers.
   * @param {HTMLElement} section - Product section.
   * @returns {boolean} Whether the independent box is configured.
   */
  function ab869en6v4eConfigured(section) {
    const config = ab869en6v4eConfig(section)
    return /^\d+$/.test(config.variantId) && /^\d+$/.test(config.sellingPlanId)
  }

  /**
   * Detect a currently selected six-bag treatment.
   * @param {HTMLElement} section - Product section.
   * @returns {boolean} Whether six-bag controls own this section.
   */
  function ab869en6v4eIsActive(section) {
    return window.ab869en6v4eSixBags === true && ab869en6v4eStates.has(section)
  }

  /**
   * Fetch the six-bag box without sharing three-bag state or requests.
   * @param {HTMLElement} section - Product section.
   * @returns {Promise<object>} Validated Skio box, including eligible components.
   */
  function ab869en6v4eEnsureBox(section) {
    const config = ab869en6v4eConfig(section)
    if (ab869en6v4eBoxes.has(config.key)) {
      return ab869en6v4eBoxes.get(config.key)
    }
    const request = fetch('https://api.skio.com/storefront-http/get-classic-box-v2', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        productVariantPlatformId: config.variantId,
        sellingPlanPlatformId: config.sellingPlanId,
      }),
    }).then((response) => {
      if (!response.ok) {
        throw new Error(section.dataset.ab869en6v4eLoadError)
      }
      return response.json()
    }).then((data) => {
      const box = data && data.ClassicBoxV2
      if (!data || !data.ok || !box || Number(box.size) !== 6 || !/6 months?/i.test(box.sellingPlan || '')) {
        throw new Error(section.dataset.ab869en6v4eUnavailable)
      }
      return box
    }).catch((error) => {
      ab869en6v4eBoxes.delete(config.key)
      throw error
    })
    ab869en6v4eBoxes.set(config.key, request)
    return request
  }

  /**
   * Resolve an available fulfilment component for a displayed flavour.
   * @param {object} box - Validated six-bag box.
   * @param {string} flavour - Merchant flavour name from the tile.
   * @returns {number} Available component variant ID, or zero.
   */
  function ab869en6v4eComponent(box, flavour) {
    const target = String(flavour || '').trim().toLowerCase()
    const match = (box.selectableProductVariants || []).find((variant) => {
      const name = (variant.productVariantTitle || '').split(' / ')[0].trim().toLowerCase()
      return name === target && !variant.outOfStock
    })
    return match ? Number(String(match.platformId).split('/').pop()) || 0 : 0
  }

  /**
   * Reflect six-bag allocations in the shared visual controls.
   * @param {HTMLElement} section - Active six-bag section.
   * @returns {void}
   */
  function ab869en6v4eRender(section) {
    const state = ab869en6v4eStates.get(section)
    if (!state) {
      return
    }
    const total = Object.values(state.quantities).reduce((sum, quantity) => sum + quantity, 0)
    let unavailable = false
    section.querySelectorAll('[data-rdl-build-tile]').forEach((tile) => {
      const quantity = state.quantities[tile.dataset.flavour] || 0
      const eligible = state.box && ab869en6v4eComponent(state.box, tile.dataset.flavourName) > 0
      const quantityLabel = tile.querySelector('[data-rdl-tile-qty]')
      const minus = tile.querySelector('[data-rdl-bundle-minus]')
      const plus = tile.querySelector('[data-rdl-bundle-plus]')
      unavailable = unavailable || (quantity > 0 && !eligible)
      tile.classList.toggle('is-active', quantity > 0)
      tile.classList.toggle('rdl-build-tile--unavailable', Boolean(state.box) && !eligible)
      if (quantityLabel) {
        quantityLabel.textContent = quantity
        quantityLabel.style.display = quantity > 0 ? '' : 'none'
      }
      if (minus) {
        minus.style.display = quantity > 0 ? '' : 'none'
        minus.disabled = quantity <= 0
      }
      if (plus) {
        plus.disabled = total >= 6 || !eligible
      }
    })
    const subtitle = section.querySelector('[data-rdl-build-subtitle]')
    if (subtitle) {
      subtitle.textContent = section.dataset.ab869en6v4eSubtitle
    }
    const counter = section.querySelector('[data-rdl-build-counter]')
    const label = section.querySelector('[data-rdl-build-counter-text]')
    if (label) {
      label.textContent = section.dataset.ab869en6v4eSelected.replace('[count]', total)
    }
    if (counter) {
      counter.classList.toggle('is-complete', total === 6 && !unavailable)
    }
    const button = section.querySelector('.rdl-atc')
    if (button) {
      const incomplete = total !== 6 || unavailable || !state.box
      button.disabled = incomplete || ab869en6v4eCartPending || button.classList.contains('is-loading')
      button.classList.toggle('rdl-atc--incomplete', incomplete)
    }
    ab869en6v4eLockPending(section)
  }

  /**
   * Start six-bag selection with the current flavour and load its box.
   * @param {HTMLElement} section - Configured treatment section.
   * @returns {void}
   */
  function ab869en6v4eEnter(section) {
    const subtitle = section.querySelector('[data-rdl-build-subtitle]')
    const selected = section.querySelector('.rdl-flavour.is-selected')
    const quantities = {}
    section.querySelectorAll('[data-rdl-build-tile]').forEach((tile) => {
      quantities[tile.dataset.flavour] = 0
    })
    const flavour = selected && selected.dataset.flavour
    const initial = Object.prototype.hasOwnProperty.call(quantities, flavour) ? flavour : Object.keys(quantities)[0]
    if (initial) {
      quantities[initial] = 6
    }
    const state = {
      quantities,
      box: null,
      subtitle: subtitle ? subtitle.textContent : '',
    }
    ab869en6v4eStates.set(section, state)
    section.classList.add('rdl-bundle-mode')
    section.querySelector('.rdl-flavours__build')?.removeAttribute('aria-hidden')
    const counter = section.querySelector('[data-rdl-build-counter-text]')
    if (counter) {
      counter.setAttribute('role', 'status')
      counter.setAttribute('aria-live', 'polite')
      counter.setAttribute('aria-atomic', 'true')
    }
    ab869en6v4eRender(section)
    ab869en6v4eEnsureBox(section).then((box) => {
      if (ab869en6v4eStates.get(section) !== state) {
        return
      }
      state.box = box
      ab869en6v4eRender(section)
    }).catch((error) => {
      if (ab869en6v4eStates.get(section) !== state) {
        return
      }
      const errorLabel = section.querySelector('[data-rdl-atc-error]')
      if (errorLabel) {
        errorLabel.textContent = error.message
        errorLabel.removeAttribute('hidden')
      }
      ab869en6v4eRender(section)
    })
  }

  /**
   * Return shared controls to their original one/three-bag state.
   * @param {HTMLElement} section - Section leaving six-bag selection.
   * @returns {void}
   */
  function ab869en6v4eExit(section) {
    const state = ab869en6v4eStates.get(section)
    const subtitle = section.querySelector('[data-rdl-build-subtitle]')
    if (subtitle && state) {
      subtitle.textContent = state.subtitle
    }
    const counter = section.querySelector('[data-rdl-build-counter-text]')
    if (counter) {
      counter.removeAttribute('role')
      counter.removeAttribute('aria-live')
      counter.removeAttribute('aria-atomic')
    }
    section.querySelectorAll('[data-rdl-build-tile]').forEach((tile) => {
      tile.classList.remove('rdl-build-tile--unavailable')
    })
    ab869en6v4eStates.delete(section)
    rdlExitBuildMode(section)
  }

  /**
   * Apply one user-initiated quantity change within the six-bag limit.
   * @param {HTMLElement} section - Active treatment section.
   * @param {HTMLButtonElement} control - Pressed plus or minus button.
   * @param {boolean} increase - Whether the quantity increases.
   * @returns {void}
   */
  function ab869en6v4eStep(section, control, increase) {
    const state = ab869en6v4eStates.get(section)
    const tile = control.closest('[data-rdl-build-tile]')
    if (!state || !tile || control.disabled) {
      return
    }
    const flavour = tile.dataset.flavour
    const current = state.quantities[flavour] || 0
    const total = Object.values(state.quantities).reduce((sum, quantity) => sum + quantity, 0)
    if (increase && total < 6) {
      state.quantities[flavour] = current + 1
    } else if (!increase && current > 0) {
      state.quantities[flavour] = current - 1
    }
    ab869en6v4eRender(section)
  }

  /**
   * Submit one six-bag parent and its linked gifts through the existing cart API.
   * @param {HTMLElement} section - Active treatment section.
   * @param {HTMLButtonElement} button - Product add-to-cart button.
   * @param {HTMLElement} errorLabel - Existing visible error container.
   * @returns {void}
   */
  function ab869en6v4eAddToCart(section, button, errorLabel) {
    const state = ab869en6v4eStates.get(section)
    const total = state && Object.values(state.quantities).reduce((sum, quantity) => sum + quantity, 0)
    if (!state?.box || total !== 6 || button?.classList.contains('is-loading')) {
      return
    }
    try {
      const config = ab869en6v4eConfig(section)
      const parentId = Number(config.variantId)
      const groupId = Date.now() + '-' + Math.random().toString(16).slice(2)
      const properties = { _box_group_id: groupId }
      const bundleParts = []
      section.querySelectorAll('[data-rdl-build-tile]').forEach((tile) => {
        const quantity = state.quantities[tile.dataset.flavour] || 0
        if (!quantity) {
          return
        }
        const variantId = ab869en6v4eComponent(state.box, tile.dataset.flavourName)
        if (!variantId) {
          throw new Error(section.dataset.ab869en6v4eUnavailable)
        }
        // Skio expands these components after order creation; never add them twice.
        properties['_pvgid://shopify/ProductVariant/' + variantId] = quantity
        bundleParts.push(quantity + 'x ' + tile.dataset.flavourName)
      })
      const giftSource = section.querySelector('[data-ab869en6v4e-option]')
      const gifts = window.ThatWorks?.freeGiftsWithSubscriptionOfVariants?.[giftSource?.dataset.giftVariantId]
      if (!Array.isArray(gifts) || gifts.length === 0) {
        throw new Error(section.dataset.ab869en6v4eGiftError)
      }
      const giftItems = gifts.map((gift) => {
        const variantId = rdlNormalizeVariantId(gift.variantId)
        if (!variantId || gift.autoAddDisabled === true || gift.autoAddDisabled === 'true') {
          throw new Error(section.dataset.ab869en6v4eGiftError)
        }
        return {
          id: variantId,
          quantity: 1,
          parent_id: parentId,
          properties: {
            _is_free_gift: 'true',
            __free_gift: true,
            _free_gift_child: 'true',
            _free_gift_group_id: groupId,
            _free_gift_parent_variant_id: String(parentId),
          },
        }
      })
      Object.assign(properties, {
        Bundle: bundleParts.join(', '),
        _free_gift_parent: 'true',
        _free_gift_group_id: groupId,
        _free_gift_parent_variant_id: String(parentId),
        _is_free_gift: 'false',
        __free_gift_items: giftItems.map((item) => String(item.id)).join(','),
      })
      const parent = {
        id: parentId,
        quantity: 1,
        selling_plan: Number(config.sellingPlanId),
        properties,
      }
      if (button) {
        button.disabled = true
        button.classList.add('is-loading')
      }
      rdlDoCartAdd([parent].concat(giftItems), button, errorLabel)
    } catch (error) {
      if (errorLabel) {
        errorLabel.textContent = error.message
        errorLabel.removeAttribute('hidden')
      }
      ab869en6v4eRender(section)
    }
  }

  /**
   * Expose the treatment only after explicit Intelligems activation.
   * @param {HTMLElement} section - Product section to check.
   * @returns {void}
   */
  function ab869en6v4eActivate(section) {
    const ready = section.querySelector('[data-ab869en6v4e-ready="true"]')
    const enabled = window.ab869en6v4eSixBags === true && Boolean(ready) && ab869en6v4eConfigured(section)
    section.classList.toggle('ab-869en6v4e-six-bags', enabled)
    if (ready) {
      ready.disabled = !enabled
    }
    if (!enabled && ab869en6v4eStates.has(section)) {
      ab869en6v4eExit(section)
      rdlApplyBundleSelection(section, '1x')
    }
    if (enabled && rdlPendingHistory.has(section)) {
      const saved = rdlPendingHistory.get(section)
      rdlPendingHistory.delete(section)
      rdlApplyHistorySelection(section, saved)
    }
  }

  /**
   * Ignore preview parameters removed by Shopify and Intelligems after load.
   * @returns {string} Product URL including meaningful query parameters.
   */
  function rdlHistoryUrl() {
    const params = new URLSearchParams(window.location.search)
    for (const key of ['preview_theme_id', 'ig-preview', 'igTg', 'pb']) {
      params.delete(key)
    }
    params.sort()
    const query = params.toString()
    return window.location.pathname + (query ? '?' + query : '')
  }

  /**
   * Identify a picker without sharing choices between products or sections.
   * @param {HTMLElement} section - Product picker.
   * @returns {string} History key.
   */
  function rdlHistoryKey(section) {
    return section.dataset.sectionId + ':' + section.dataset.productId
  }

  /**
   * Capture choices without persisting product or pricing data.
   * @param {HTMLElement} section - Product picker.
   * @returns {Object} Bundle value and flavour quantities.
   */
  function rdlCurrentChoice(section) {
    const selected = section.querySelector('.rdl-bundle__input:checked')
    const sixState = ab869en6v4eStates.get(section)
    return {
      bundleValue: selected ? selected.value : '1x',
      quantities: { ...(sixState ? sixState.quantities : rdlBundleState) },
    }
  }

  /**
   * Give a new customer choice precedence over delayed page restoration.
   * @param {HTMLElement} section - Product picker the customer changed.
   * @returns {void}
   */
  function rdlRememberChoice(section) {
    rdlPendingHistory.delete(section)
    rdlUserChoices.set(section, rdlCurrentChoice(section))
    rdlSaveHistorySelection()
  }

  /**
   * Save only customer choices on the current browser history entry.
   * Prices, variants and plans always come from the current product markup.
   * @returns {void}
   */
  function rdlSaveHistorySelection() {
    if (rdlRenderedUrl !== rdlHistoryUrl()) {
      return
    }
    const sections = {}
    document.querySelectorAll('[data-rdl-section]').forEach((section) => {
      sections[rdlHistoryKey(section)] = rdlPendingHistory.get(section) || rdlCurrentChoice(section)
    })
    try {
      history.replaceState({
        ...history.state,
        rdlBundleSelections: { url: rdlRenderedUrl, sections },
      }, '')
    } catch (error) {
      // A browser may reject history writes while the document is leaving.
    }
  }

  /**
   * Restore a validated allocation using current offer and stock information.
   * @param {HTMLElement} section - Product picker.
   * @param {Object} saved - Bundle value and optional flavour quantities.
   * @returns {void}
   */
function rdlApplyHistorySelection(section, saved) {
  if (!saved || ![
    '1x',
    '3x',
    '6x',
  ].includes(saved.bundleValue)) {
    return
  }
  if (saved.bundleValue === '6x' &&
    !section.classList.contains('ab-869en6v4e-six-bags')) {
    rdlPendingHistory.set(section, saved)
    const selected = section.querySelector('.rdl-bundle__input:checked')
    rdlApplyBundleSelection(
      section,
      selected && selected.value !== '6x' ? selected.value : '1x',
    )
    return
  }
  rdlApplyRetainedSelection(section, saved.bundleValue)
  const size = saved.bundleValue === '6x'
    ? 6
    : saved.bundleValue === '3x' ? 3 : 0
  if (!size || !saved.quantities || typeof saved.quantities !== 'object') {
    return
  }
  const flavours = Array.from(
    section.querySelectorAll('[data-rdl-build-tile]'),
    (tile) => tile.dataset.flavour,
  )
  const entries = Object.entries(saved.quantities)
  const valid = entries.every(([
    flavour,
    quantity,
  ]) => (
    flavours.includes(flavour) &&
    Number.isInteger(quantity) &&
    quantity >= 0 && quantity <= size
  ))
  if (!valid || entries.reduce((sum, entry) => sum + entry[1], 0) > size) {
    return
  }
  if (size === 6) {
    const state = ab869en6v4eStates.get(section)
    if (state) {
      state.quantities = Object.fromEntries(flavours.map((flavour) => [
        flavour,
        saved.quantities[flavour] || 0,
      ]))
      ab869en6v4eRender(section)
    }
  } else if (rdlBuilderConfigured(section)) {
    rdlApplyAllocation(section, saved.quantities)
  }
}

  /**
   * Reconcile both pickers after cached and full-document Back navigation.
   * @param {HTMLElement} section - Product picker.
   * @returns {void}
   */
  function rdlRestoreHistorySelection(section) {
    const snapshot = history.state && history.state.rdlBundleSelections
    const stored = snapshot && snapshot.url === rdlRenderedUrl && snapshot.sections
      ? snapshot.sections[rdlHistoryKey(section)]
      : null
    const saved = rdlUserChoices.get(section) || stored
    if (saved) {
      rdlApplyHistorySelection(section, saved)
      return
    }
    const selected = section.querySelector('.rdl-bundle__input:checked')
    if (selected) {
      rdlApplyHistorySelection(section, { bundleValue: selected.value })
    }
  }

  window.addEventListener('pagehide', rdlSaveHistorySelection)
  window.addEventListener('popstate', () => {
    rdlNavigationId += 1
    if (rdlRenderedUrl !== rdlHistoryUrl()) {
      window.location.reload()
    } else {
      document.querySelectorAll('[data-rdl-section]').forEach((section) => {
        rdlUserChoices.delete(section)
        rdlPendingHistory.delete(section)
        section.classList.remove('rdl-loading')
      })
      setTimeout(() => {
        document.querySelectorAll('[data-rdl-section]').forEach(rdlRestoreHistorySelection)
      }, 0)
    }
  })
  window.addEventListener('pageshow', () => {
    // History traversal can restore form controls after pageshow has fired.
    setTimeout(() => {
      document.querySelectorAll('[data-rdl-section]').forEach(rdlRestoreHistorySelection)
    }, 0)
  })

  document.addEventListener('ab:869en6v4e:activate', () => {
    document.querySelectorAll('[data-rdl-section]').forEach(ab869en6v4eActivate)
  })
  document.querySelectorAll('[data-rdl-section]').forEach(ab869en6v4eActivate)
  setTimeout(() => {
    document.querySelectorAll('[data-rdl-section]').forEach(rdlRestoreHistorySelection)
  }, 0)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rd-lymphoria-how"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.rdh').forEach(function (sec) {
      var track = sec.querySelector('[data-rdh-track]');
      if (!track) return;
      var prev = sec.querySelector('[data-rdh-prev]');
      var next = sec.querySelector('[data-rdh-next]');
      var dotsWrap = sec.querySelector('[data-rdh-dots]');
      var cards = track.querySelectorAll('.rdh__card');
      if (!cards.length) return;
      function step() { var c = cards[0]; return c ? c.getBoundingClientRect().width + 12 : 320; }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      if (dotsWrap) {
        dotsWrap.innerHTML = '';
        cards.forEach(function (c, i) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'rdh__dot';
          b.setAttribute('aria-label', 'Go to step ' + (i + 1));
          b.addEventListener('click', function () { track.scrollTo({ left: i * step(), behavior: 'smooth' }); });
          dotsWrap.appendChild(b);
        });
        var dots = dotsWrap.querySelectorAll('.rdh__dot');
        function sync() {
          var idx = Math.round(track.scrollLeft / step());
          dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
        }
        sync();
        track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rd-lymphoria-ingredients"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.rdi').forEach(function (sec) {
      var track = sec.querySelector('[data-rdi-track]');
      if (!track) return;
      var prev = sec.querySelector('[data-rdi-prev]');
      var next = sec.querySelector('[data-rdi-next]');
      var dotsWrap = sec.querySelector('[data-rdi-dots]');
      var cards = track.querySelectorAll('.rdi__card');
      if (!cards.length) return;

      function step() { var c = cards[0]; return c ? c.getBoundingClientRect().width + 12 : 320; }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

      if (dotsWrap) {
        dotsWrap.innerHTML = '';
        cards.forEach(function (c, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'rdi__dot';
          b.setAttribute('aria-label', 'Go to ingredient ' + (i + 1));
          b.addEventListener('click', function () { track.scrollTo({ left: i * step(), behavior: 'smooth' }); });
          dotsWrap.appendChild(b);
        });
        var dots = dotsWrap.querySelectorAll('.rdi__dot');
        function sync() {
          var idx = Math.round(track.scrollLeft / step());
          dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
        }
        sync();
        track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rd-lymphoria-journey"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var lists = document.querySelectorAll('[data-rdj-list]');
    if (!lists.length) return;

    function setupList(list) {
      var fill = list.querySelector('[data-rdj-fill]');
      var items = list.querySelectorAll('[data-rdj-item]');
      if (!fill || !items.length) return;

      function update() {
        var listRect = list.getBoundingClientRect();
        var triggerY = window.innerHeight * 0.7;
        var lastY = 0;

        items.forEach(function (item) {
          var marker = item.querySelector('.rdj__marker');
          if (!marker) return;
          var rect = marker.getBoundingClientRect();
          var centerY = rect.top + rect.height / 2;
          if (centerY <= triggerY) {
            item.classList.add('is-active');
            lastY = Math.max(lastY, rect.top + rect.height / 2 - listRect.top - 11);
          } else {
            item.classList.remove('is-active');
          }
        });

        fill.style.height = lastY + 'px';
      }

      window.addEventListener('scroll', function () {
        window.requestAnimationFrame(update);
      }, { passive: true });
      window.addEventListener('resize', update);
      update();
      // Re-run a few times after load to catch fonts/images shifting layout.
      setTimeout(update, 300);
      setTimeout(update, 1000);
    }

    lists.forEach(setupList);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rd-lymphoria-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('.rdr');
    sections.forEach(function (sec) {
      var track = sec.querySelector('[data-rdr-track]');
      if (!track) return;
      var prevBtn = sec.querySelector('[data-rdr-prev]');
      var nextBtn = sec.querySelector('[data-rdr-next]');
      var dotsWrap = sec.querySelector('[data-rdr-dots]');
      var cards = track.querySelectorAll('.rdr__card');
      if (!cards.length) return;

      function step() {
        var card = cards[0];
        return card ? card.getBoundingClientRect().width + 12 : 320;
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (nextBtn) nextBtn.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

      // Dots
      if (dotsWrap) {
        dotsWrap.innerHTML = '';
        cards.forEach(function (c, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'rdr__dot';
          b.setAttribute('aria-label', 'Go to review ' + (i + 1));
          b.addEventListener('click', function () {
            track.scrollTo({ left: i * step(), behavior: 'smooth' });
          });
          dotsWrap.appendChild(b);
        });
        var dots = dotsWrap.querySelectorAll('.rdr__dot');

        function syncDot() {
          var idx = Math.round(track.scrollLeft / step());
          dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
        }
        syncDot();
        track.addEventListener('scroll', function () {
          window.requestAnimationFrame(syncDot);
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
